import { render, staticRenderFns } from "./aggregatedFandomTable.vue?vue&type=template&id=24b52850&"
import script from "./aggregatedFandomTable.vue?vue&type=script&lang=js&"
export * from "./aggregatedFandomTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports